var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flowEditBody"},[_c('div',{staticClass:"body"},[_c('div',{staticClass:"bodyLeft"},[_c('div',{staticClass:"Steps"},[(_vm.showFlowImage === null)?[_c('p',{staticStyle:{"font-size":"16px","color":"#000","margin-top":"36px"}},[_vm._v(" 流程图暂无 ")])]:[_c('img',{attrs:{"src":_vm.flowImage}})]],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }